import {authHeader} from "@/helpers/authservice/auth-header";
import axios from "axios";
import Swal from "sweetalert2";
import {requiredHeaders} from "@/helpers/authservice/requiredHeaders";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";
import {log} from "./log";
import {defineStore} from "pinia";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";


export const usePricesManagerModule = defineStore("pricesManagerModule", {


    state: () => ({
        lazyLoaderModule: useLazyLoaderModule(),
        //Common
        backendModuleName: "PRICES",
        prices_tasks_endpoint: "/api/prices-manager/tasks",
        prices_products_endpoint: "/api/prices-manager/products",
        prices_margins_endpoint: "/api/prices-manager/margin",
        settings_endpoint: "/api/settings",
        //User data
        user: {},

        //Settings
        settings: [],

        //Tasks
        pricesTasks: [],
        drugstoresOfTask: [],
        pricesTasksPagesCount: 0,
        pricesTasksTotal: 0,


        pricesProductsAvailableSearchOptions: [
            {
                name: "Nazwa produktu",
                ordinal: 0,
            },
            {
                name: "Bloz",
                ordinal: 1,
            },
            {
                name: "Ean",
                ordinal: 2,
            },
        ],
        //Products
        pricesProducts: [],
        pricesProductsPagesCount: 0,
        pricesProductsTotal: 0,
        //Margins
        pricesMargins: [],


    }),
    getters: {
        //Common
        getBackendModuleName: (state) => state.backendModuleName,
        //User
        getPricesManagerSettings: (state) => state.settings,
        //Tasks
        getPricesTasks: (state) => state.pricesTasks,
        getDrugstoresOfTask: (state) => state.drugstoresOfTask,
        getPricesTasksPagesCount: (state) => state.pricesTasksPagesCount,
        getPricesTasksTotal: (state) => state.pricesTasksTotal,
        //Products
        getPricesProducts: (state) => state.pricesProducts,
        getPricesProductsPagesCount: (state) => state.pricesProductsPagesCount,
        getPricesProductsTotal: (state) => state.pricesProductsTotal,
        getPricesProductsAvailableSearchOptions: (state) => state.pricesProductsAvailableSearchOptions,
        //Margins
        getPricesMargins: (state) => state.pricesMargins,
    },
    actions: {
        setPricesManagerUser( user) {
            this.user = user;
        },
        setPricesManagerSettings( settings) {
            this.settings = settings;
        },

        //Tasks
        setPricesTasks( pricesTasks) {
            log.log("setting tasks")
            this.pricesTasks = pricesTasks;
        },

        setDrugstoresOfTask( drugstoresOfTask) {
            this.drugstoresOfTask = drugstoresOfTask;
        },

        setPricesTasksPagesCount( pricesTasksPagesCount) {
            this.pricesTasksPagesCount = pricesTasksPagesCount;
        },

        setPricesTasksTotal( pricesTasksTotal) {
            this.pricesTasksTotal = pricesTasksTotal;
        },
        //Products
        setPricesProducts( pricesProducts) {
            this.pricesProducts = pricesProducts;
        },
        setPricesProductsPagesCount( pricesProductsPagesCount) {
            this.pricesProductsPagesCount = pricesProductsPagesCount;
        },
        setPricesProductsTotal( pricesProductsTotal) {
            this.pricesProductsTotal = pricesProductsTotal;
        },
        //Margins
        setPricesMargins( pricesMargins) {
            this.pricesMargins = pricesMargins;
        },
        //Settings
        setPackagesManagerSettings( settings) {
            this.settings = settings;
        },

        // actions
        // =================================================== new api for packages ================================================
        httpGetPricesTasksPaging( payload) {
            var pageNumber = payload.page;
            var endpoint_last_part = "/all/pages?page=";

            var endpoint = this.prices_tasks_endpoint + endpoint_last_part + pageNumber;
            if (payload.sortingKey) {
                endpoint = endpoint + "&sortingKey=" + payload.sortingKey;
            }
            if (payload.sortingDirection) {
                endpoint = endpoint + "&sortingDirection=" + payload.sortingDirection;
            }

            return axios({
                method: "get",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
            })
                .then((response) => {
                    log.log("httpGetPricesTasksPaging response:");
                    log.log(response);
                    if (response.status === 200) {
                       this.setPricesTasksPagesCount(response.data.payload.totalPages
                        );
                       this.setPricesTasksTotal(response.data.payload.totalElements
                        );
                        this.setPricesTasks(response.data.payload.content);
                    } else if (response.status === 203) {
                        log.log(response);
                        Swal.fire("Coś jest nie tak!", response.message, "warning");
                    } else {
                        var errorMessage = "";
                        if (response.data.message) {
                            errorMessage = response.data.message;
                        }
                        log.log("Wystąpił błąd!: " + errorMessage);
                        Swal.fire("Wystąpił błąd!", errorMessage, "error")
                    }
                })
                .catch((error) => {
                    log.log("Wystąpił błąd!: " + error);
                    Swal.fire("Wystąpił błąd!", error + "", "error")
                });
        },

        httpGetPricesProductsForTaskCentralIdPaging( payload) {
            var taskCentralId = payload.taskCentralId;
            var excluded = payload.excluded;
            var pageNumber = payload.currentPage;
            var filterRequestObject = payload.searchAndFilterRequest;

            var endpoint_last_part = "/task/" + taskCentralId + "/excluded/" + excluded + "/pages?page=";
            var endpoint = this.prices_products_endpoint + endpoint_last_part + pageNumber;
            if (payload.sortingKey) {
                endpoint = endpoint + "&sortingKey=" + payload.sortingKey;
            }
            if (payload.sortingDirection) {
                endpoint = endpoint + "&sortingDirection=" + payload.sortingDirection;
            }

            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: filterRequestObject,
            })
                .then((response) => {
                    log.log("httpGetPricesProductsForTaskCentralIdPaging response:");
                    log.log(response);
                    if (response.status === 200) {
                       this.setPricesTasksPagesCount(response.data.payload.totalPages
                        );
                       this.setPricesProductsTotal(response.data.payload.totalElements
                        );
                        this.setPricesProducts(response.data.payload.content);
                    } else if (response.status === 203) {
                        log.log(response);
                        Swal.fire("Coś jest nie tak!", response.message, "warning");
                    } else {
                        var errorMessage = "";
                        if (response.data.message) {
                            errorMessage = response.data.message;
                        }
                        log.log("Wystąpił błąd!: " + errorMessage);
                        Swal.fire("Wystąpił błąd!", errorMessage, "error")
                    }
                })
                .catch((error) => {
                    log.log("Wystąpił błąd!: " + error);
                    Swal.fire("Wystąpił błąd!", error + "", "error")
                });
        },

        httpGetPricesProductsPaging( payload) {
            var excluded = payload.excluded;
            var pageNumber = payload.currentPage;
            var filterRequestObject = payload.searchAndFilterRequest;

            var endpoint_last_part = "/all/excluded/" + excluded + "/pages?page=";
            var endpoint = this.prices_products_endpoint + endpoint_last_part + pageNumber;
            if (payload.sortingKey) {
                endpoint = endpoint + "&sortingKey=" + payload.sortingKey;
            }
            if (payload.sortingDirection) {
                endpoint = endpoint + "&sortingDirection=" + payload.sortingDirection;
            }

            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: filterRequestObject,
            })
                .then((response) => {
                    log.log("httpGetPricesProductsForTaskCentralIdPaging response:");
                    log.log(response);
                    if (response.status === 200) {
                       this.setPricesTasksPagesCount(response.data.payload.totalPages
                        );
                       this.setPricesProductsTotal(response.data.payload.totalElements
                        );
                        this.setPricesProducts(response.data.payload.content);
                    } else if (response.status === 203) {
                        log.log(response);
                        Swal.fire("Coś jest nie tak!", response.message, "warning");
                    } else {
                        var errorMessage = "";
                        if (response.data.message) {
                            errorMessage = response.data.message;
                        }
                        log.log("Wystąpił błąd!: " + errorMessage);
                        Swal.fire("Wystąpił błąd!", errorMessage, "error")
                    }
                })
                .catch((error) => {
                    log.log("Wystąpił błąd!: " + error);
                    Swal.fire("Wystąpił błąd!", error + "", "error")
                });
        },

        httpGetPricesMarginsForTaskCentralId( payload) {
            var taskCentralId = payload.taskCentralId;
            var endpoint_last_part = "/task/" + taskCentralId;

            var endpoint = this.prices_margins_endpoint + endpoint_last_part;

            return axios({
                method: "get",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
            })
                .then((response) => {
                    log.log("httpGetPricesMarginsForTaskCentralId response:");
                    log.log(response);
                    if (response.status === 200) {
                        this.setPricesMargins(response.data.payload.content);
                    } else if (response.status === 203) {
                        log.log(response);
                        Swal.fire("Coś jest nie tak!", response.message, "warning");
                    } else {
                        var errorMessage = "";
                        if (response.data.message) {
                            errorMessage = response.data.message;
                        }
                        log.log("Wystąpił błąd!: " + errorMessage);
                        Swal.fire("Wystąpił błąd!", errorMessage, "error")
                    }
                })
                .catch((error) => {
                    log.log("Wystąpił błąd!: " + error);
                    Swal.fire("Wystąpił błąd!", error + "", "error")
                });
        },

        httpGetTaskByCentralId( payload) {
            var endpoint = this.prices_tasks_endpoint + "/centralId/" + payload.centralId;
            // this.commonModule.setDisplayLazyLoader(true);
            // this.lazyLoaderModule.setProgressBarMessage("Trwa pobieranie danych z centrali...");
            return axios({
                method: "get",
                url: endpoint,
                headers: authHeader(),
                data: payload,
            })

        },

        httpAddTask( payload) {
            var endpoint = this.prices_tasks_endpoint + "/add";
            this.lazyLoaderModule.setDisplayLazyLoader(true);
            this.lazyLoaderModule.setProgressBarMessage("Trwa wysyłanie danych do centrali...");
            return axios({
                method: "post",
                url: endpoint,
                headers: authHeader(),
                data: payload.taskDto,
            })
                .then((response) => {
                    apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    apiRequestsHelper.catchResponseError(error, "httpAddTask");
                });
        },

        httpUpdateTask( payload) {
            var taskCentralId = payload.taskCentralId;
            var endpoint = this.prices_tasks_endpoint + "/update/" + taskCentralId;
            this.lazyLoaderModule.setDisplayLazyLoader(true);
            this.lazyLoaderModule.setProgressBarMessage("Trwa wysyłanie danych do centrali...");
            return axios({
                method: "put",
                url: endpoint,
                headers: authHeader(),
                data: payload.taskDto,
            })
                .then((response) => {
                    apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    apiRequestsHelper.catchResponseError(error, "httpUpdateTask");
                });
        },

        httpSaveTasksProductListSource( payload) {
            var taskCentralId = payload.taskCentralId;
            var endpoint = this.prices_tasks_endpoint + "/task/" + taskCentralId + "/productListSource";
            this.lazyLoaderModule.setDisplayLazyLoader(true);
            this.lazyLoaderModule.setProgressBarMessage("Trwa wysyłanie danych do centrali...");
            return axios({
                method: "post",
                url: endpoint,
                headers: authHeader(),
                data: payload,
            })
                .then((response) => {
                    apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    this.lazyLoaderModule.setDisplayLazyLoader(false);
                    this.lazyLoaderModule.setProgressBarMessage("");
                    log.log("Wystąpił błąd!: " + error);
                    Swal.fire("Wystąpił błąd!", error + "", "error")
                });
        },

        httpRemoveTask( payload) {
            var taskCentralId = payload.centralId;
            var endpoint = this.prices_tasks_endpoint + "/delete/centralId/" + taskCentralId;
            this.lazyLoaderModule.setDisplayLazyLoader(true);
            this.lazyLoaderModule.setProgressBarMessage("Trwa wysyłanie danych do centrali...");
            return axios({
                method: "delete",
                url: endpoint,
                headers: authHeader(),
                data: {},
            })
                .then((response) => {
                    apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    this.lazyLoaderModule.setDisplayLazyLoader(false);
                    this.lazyLoaderModule.setProgressBarMessage("");
                    log.log("Wystąpił błąd!: " + error);
                    Swal.fire("Wystąpił błąd!", error + "", "error")
                });
        },

        httpRemoveProduct( payload) {
            var productCentralId = payload.centralId;
            var endpoint = this.prices_products_endpoint + "/delete/centralId/" + productCentralId;
            this.lazyLoaderModule.setDisplayLazyLoader(true);
            this.lazyLoaderModule.setProgressBarMessage("Trwa wysyłanie danych do centrali...");
            return axios({
                method: "delete",
                url: endpoint,
                headers: authHeader(),
                data: {},
            })
                .then((response) => {
                    apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    this.lazyLoaderModule.setDisplayLazyLoader(false);
                    this.lazyLoaderModule.setProgressBarMessage("");
                    log.log("Wystąpił błąd!: " + error);
                    Swal.fire("Wystąpił błąd!", error + "", "error")
                });
        },

        httpGetDrugstoresForTaskCentralId( payload) {
            var taskCentralId = payload.taskCentralId;
            var endpoint_last_part = "/drugstores/task/" + taskCentralId;

            var endpoint = this.prices_tasks_endpoint + endpoint_last_part;

            return axios({
                method: "get",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
            })
        },

        httpAddDrugstoreToTask( payload) {
            var taskCentralId = payload.taskCentralId;
            var drugstoreClientId = payload.drugstoreClientId;
            var endpoint = this.prices_tasks_endpoint + "/drugstore/kamsoft/" + drugstoreClientId + "/task/" + taskCentralId;
            this.lazyLoaderModule.setDisplayLazyLoader(true);
            this.lazyLoaderModule.setProgressBarMessage("Trwa wysyłanie danych do centrali...");
            return axios({
                method: "put",
                url: endpoint,
                headers: authHeader(),
                data: {},
            })
                .then((response) => {
                    apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    this.lazyLoaderModule.setDisplayLazyLoader(false);
                    this.lazyLoaderModule.setProgressBarMessage("");
                    log.log("Wystąpił błąd!: " + error);
                    Swal.fire("Wystąpił błąd!", error + "", "error")
                });
        },

        httpSaveMarginForTask( payload) {
            var taskCentralId = payload.taskCentralId;
            var marginToSave = payload.marginValueRange;
            var endpoint = this.prices_margins_endpoint + "/task/" + taskCentralId + "/margin/save";
            this.lazyLoaderModule.setDisplayLazyLoader(true);
            this.lazyLoaderModule.setProgressBarMessage("Trwa wysyłanie danych do centrali...");
            return axios({
                method: "post",
                url: endpoint,
                headers: authHeader(),
                data: marginToSave,
            })
                .then((response) => {
                    apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    this.lazyLoaderModule.setDisplayLazyLoader(false);
                    this.lazyLoaderModule.setProgressBarMessage("");
                    log.log("Wystąpił błąd!: " + error);
                    Swal.fire("Wystąpił błąd!", error + "", "error")
                });
        },

        httpRemoveMargin( payload) {
            var marginGuid = payload.marginGuid;
            var endpoint = this.prices_margins_endpoint + "/delete/guid/" + marginGuid;
            this.lazyLoaderModule.setDisplayLazyLoader(true);
            this.lazyLoaderModule.setProgressBarMessage("Trwa wysyłanie danych do centrali...");
            return axios({
                method: "delete",
                url: endpoint,
                headers: authHeader(),
                data: {},
            })
                .then((response) => {
                    apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    this.lazyLoaderModule.setDisplayLazyLoader(false);
                    this.lazyLoaderModule.setProgressBarMessage("");
                    log.log("Wystąpił błąd!: " + error);
                    Swal.fire("Wystąpił błąd!", error + "", "error")
                });
        },

        // Procedures
        httpUpdateTasksInLocalDrugstoreProcedure() {
            var endpoint = this.prices_tasks_endpoint + "/updateTasksInLocalDrugstore";
            this.lazyLoaderModule.setDisplayLazyLoader(true);
            this.lazyLoaderModule.setProgressBarMessage("Trwa aktualizacja strategii cenowych z centrali...");
            return axios({
                method: "post",
                url: endpoint,
                headers: authHeader(),
                data: {},
            })
                .then((response) => {
                    apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    apiRequestsHelper.catchResponseError(error, "httpUpdateTasksInLocalDrugstoreProcedure");
                });
        },

        httpExportPricesFromSourceDrugstoreToCentralProcedure() {
            var endpoint = this.prices_tasks_endpoint + "/exportPricesFromSourceDrugstoreToCentral";
            this.lazyLoaderModule.setDisplayLazyLoader(true);
            this.lazyLoaderModule.setProgressBarMessage("Trwa export cen do centrali...");
            return axios({
                method: "post",
                url: endpoint,
                headers: authHeader(),
                data: {},
            })
                .then((response) => {
                    apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    apiRequestsHelper.catchResponseError(error, "httpExportPricesFromSourceDrugstoreToCentralProcedure");
                });
        },

        httpExecuteTaskInLocalDrugstoreProcedure( payload) {
            var endpoint = this.prices_tasks_endpoint + "/executeTaskInLocalDrugstore/onlySimulation/" + payload.onlySimulation;
            this.lazyLoaderModule.setDisplayLazyLoader(true);
            this.lazyLoaderModule.setProgressBarMessage("Trwa zmiany cen w aptece...");
            return axios({
                method: "post",
                url: endpoint,
                headers: authHeader(),
                data: {},
            })
                .then((response) => {
                    apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    apiRequestsHelper.catchResponseError(error, "httpExecuteTaskInLocalDrugstoreProcedure");
                });
        },

        httpRestorePricesFromLastArchiveProcedure() {
            var endpoint = this.prices_tasks_endpoint + "/restorePricesFromLastArchive";
            this.lazyLoaderModule.setDisplayLazyLoader(true);
            this.lazyLoaderModule.setProgressBarMessage("Trwa zmiany cen w aptece...");
            return axios({
                method: "post",
                url: endpoint,
                headers: authHeader(),
                data: {},
            })
                .then((response) => {
                    apiRequestsHelper.handleResponseWithDialogs(response, true);
                })
                .catch((error) => {
                    apiRequestsHelper.catchResponseError(error, "httpRestorePricesFromLastArchiveProcedure");
                });
        },

        httpGetLastArchiveFileName() {
            var endpoint_last_part = "/archives/last";
            var endpoint = this.prices_tasks_endpoint + endpoint_last_part;

            return axios({
                method: "get",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
            })
        },


        //Settings
        httpGetPricesManagerSettings() {
            var endpoint = this.settings_endpoint + "/module/" + this.backendModuleName;
            return axios({
                method: "get",
                url: endpoint,
                headers: {
                    Authorization: authHeader(),
                    appToken: "abc",
                },
                data: {},
            })
                .then((response) => {
                    if (response.status === 200) {
                        log.log("Displaying settings payload:");
                        log.log(response.data.payload);
                        this.setPackagesManagerSettings(response.data.payload);
                    } else if (response.status === 203) {
                        log.log(response);
                        Swal.fire("Coś jest nie tak!", response.message, "warning");
                    } else {
                        var errorMessage = "";
                        if (response.data.message) {
                            errorMessage = response.data.message;
                        }
                        log.log("Wystąpił błąd!: " + errorMessage);
                        Swal.fire("Wystąpił błąd!", errorMessage, "error");
                    }
                })
                .catch((error) => {
                    log.log("Catch: Wystąpił błąd!: " + error);
                    Swal.fire("Wystąpił błąd!", error + "", "error");
                });
        },

    }


});
